(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-z2-expo"] && !Shopify.designMode) return;
  try {
    
function initBbZ2Expo(){
 'use strict';
 const root=document.getElementById('bb-z2-expo');
 if(!root||root.dataset.initialized)return;
 root.dataset.initialized='true';
 const q=s=>root.querySelector(s);
 root.style.setProperty('--z2-scroll-offset','24px');
 const images=JSON.parse(q('#z2-image-data').textContent);
 const strings=JSON.parse(q('#z2-strings').textContent);
 const colors={foret:{name:strings.runtime_01,text:strings.runtime_05,caption:strings.runtime_09},perle:{name:strings.runtime_02,text:strings.runtime_06,caption:strings.runtime_10},graphite:{name:strings.runtime_03,text:strings.runtime_07,caption:strings.runtime_11},noir:{name:strings.runtime_04,text:strings.runtime_08,caption:strings.runtime_12}};
 root.querySelectorAll('[data-z2-color]').forEach(button=>button.addEventListener('click',()=>{
  const key=button.dataset.z2Color, black=key==='noir', selected=colors[key];
  root.querySelectorAll('[data-z2-color]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
  const colorUrl=images[key];
  q('#z2-color-image').src=colorUrl;
  if(colorUrl.startsWith('https://'))q('#z2-color-image').srcset=[400,600,900,1122].map(width=>colorUrl+(colorUrl.includes('?')?'&':'?')+'width='+width+' '+width+'w').join(', ');
  q('#z2-color-image').alt=strings.runtime_14+selected.name;
  q('#z2-color-name').textContent=selected.name;
  q('#z2-color-description').textContent=selected.text;
  q('#z2-color-caption').textContent=selected.caption;
  q('.z2-black-cta').hidden=!black;
 }));

 root.querySelectorAll('a[href^="#"]').forEach(a=>a.addEventListener('click',e=>{
  const id=a.getAttribute('href').slice(1),target=document.getElementById(id);
  if(target&&root.contains(target)){e.preventDefault();target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});try{history.replaceState(null,'','#'+id);}catch(_){}}
 }));
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initBbZ2Expo,{once:true});}else{initBbZ2Expo();}
document.addEventListener('shopify:section:load',initBbZ2Expo);

function initBbZ2Motion(){
  const root=document.getElementById('bb-z2-expo');
  if(!root||root.dataset.motionMounted)return;
  root.dataset.motionMounted='true';
  const reduce=matchMedia('(prefers-reduced-motion: reduce)');
  const desktop=matchMedia('(min-width: 701px)');
  const definitions=[['.z2-hero-stage figure',-34],['.z2-hero-word',66],['.z2-comfort-photo img',-28],['.z2-color-stage>img',-26],['.z2-stage-mark',44],['.z2-secret-art>span',-23]];
  const items=definitions.map(([selector,amount])=>{
    const element=root.querySelector(selector);
    if(!element)return null;
    element.setAttribute('data-z2-parallax','');
    return {element,section:element.closest('section'),amount,current:0,target:0};
  }).filter(Boolean);
  const reveals=[...root.querySelectorAll('.z2-heading-row,.z2-reason-grid article,.z2-comfort-copy,.z2-details-heading,.z2-detail-grid article,.z2-color-copy,.z2-leather>div,.z2-secret>div:last-child')];
  let frame=0,measure=true,destroyed=false,revealObserver=null;
  function active(){return !reduce.matches&&desktop.matches;}
  function revealAll(){reveals.forEach(el=>el.classList.remove('z2-reveal-pending'));}
  function configure(){
    if(frame){cancelAnimationFrame(frame);frame=0;}
    if(revealObserver)revealObserver.disconnect();
    items.forEach(item=>{item.current=0;item.target=0;item.element.style.removeProperty('--z2-shift');});
    revealAll();
    root.classList.toggle('z2-motion-ready',active());
    if(!active())return;
    if('IntersectionObserver' in window){
      revealObserver=new IntersectionObserver(entries=>{
        entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.remove('z2-reveal-pending');revealObserver.unobserve(entry.target);}});
      },{rootMargin:'0px 0px -35px 0px',threshold:0.06});
      reveals.forEach(el=>{
        if(el.getBoundingClientRect().top>innerHeight){el.classList.add('z2-reveal-pending');revealObserver.observe(el);}
      });
    }
    queue();
  }
  function animate(){
    frame=0;
    if(destroyed||!active())return;
    if(measure){
      const viewport=innerHeight,rects=new Map();
      items.forEach(item=>{if(!rects.has(item.section))rects.set(item.section,item.section.getBoundingClientRect());});
      items.forEach(item=>{
        const rect=rects.get(item.section);
        const progress=Math.max(-1,Math.min(1,(viewport/2-(rect.top+rect.height/2))/((viewport+rect.height)/2)));
        item.target=progress*item.amount;
      });
      measure=false;
    }
    let moving=false;
    items.forEach(item=>{
      const difference=item.target-item.current;
      item.current=Math.abs(difference)<0.08?item.target:item.current+difference*.18;
      if(Math.abs(difference)>=0.08)moving=true;
      item.element.style.setProperty('--z2-shift',item.current.toFixed(2)+'px');
    });
    if(moving)frame=requestAnimationFrame(animate);
  }
  function queue(){measure=true;if(active()&&!frame)frame=requestAnimationFrame(animate);}
  function cleanup(){
    destroyed=true;
    if(frame)cancelAnimationFrame(frame);
    if(revealObserver)revealObserver.disconnect();
    window.removeEventListener('scroll',queue);window.removeEventListener('resize',queue);
    window.removeEventListener('pageshow',queue);window.removeEventListener('pagehide',pause);
    reduce.removeEventListener('change',configure);desktop.removeEventListener('change',configure);
    document.removeEventListener('shopify:section:unload',unload);
    revealAll();root.classList.remove('z2-motion-ready');delete root.dataset.motionMounted;
  }
  function pause(){if(frame){cancelAnimationFrame(frame);frame=0;}}
  function unload(event){if(event.target.contains(root))cleanup();}
  window.addEventListener('scroll',queue,{passive:true});
  window.addEventListener('resize',queue,{passive:true});
  window.addEventListener('pageshow',queue);window.addEventListener('pagehide',pause);
  reduce.addEventListener('change',configure);desktop.addEventListener('change',configure);
  document.addEventListener('shopify:section:unload',unload);
  configure();
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initBbZ2Motion,{once:true});}else{initBbZ2Motion();}
document.addEventListener('shopify:section:load',initBbZ2Motion);


  } catch(e) { console.error(e); }
})();
})();
